// This is used to calculate the delivery fees per location.
export default function CalculateDeliveryFees(
  communityOrders,
  importedOrder,
  location,
) {
  // The deliveryFees per location.
  const deliveryFees = {};

  // The total delivery Fees at all locations.
  let totalDeliveryFees = 0;

  // The cost of deliveries per location.
  const costOfDeliveries = {};

  // The total cost of doing deliveries
  let totalCostOfDeliveries = 0;

  // Set the current location's delivery fees to 0
  deliveryFees[location] = 0;
  // Cycle through the community orders of this location.
  Object.keys(communityOrders).forEach((customerOrder) => {
    // If the delivery fee exists and it is more that nothing.
    if (communityOrders[customerOrder].deliveryFee > 0) {
      // Add the delivery amount to the location's total
      deliveryFees[location] += parseFloat(
        communityOrders[customerOrder].deliveryFee,
      );
      // Add the delivery amount to the total of all locations.
      totalDeliveryFees += parseFloat(
        communityOrders[customerOrder].deliveryFee,
      );
    }
    // Check if the cost of delivery exists and if it does add it up.  It'll
    // repeat the same thing for each user at this location and may update if
    // there is a user with a different costOfDelivery for some reason.
    if (communityOrders[customerOrder]?.communityPickup?.costOfDelivery) {
      costOfDeliveries[
        communityOrders[customerOrder].communityPickup.locationName
      ] = communityOrders[customerOrder].communityPickup.costOfDelivery;
    }
  });

  // Cycle through the imported locations
  Object.keys(importedOrder).forEach((importedLocation) => {
    // Set importedCommunityOrders so it easy to access this location's communityOrders.
    const importedCommunityOrders =
      importedOrder[importedLocation].communityOrders;
    // Initialise the current location's packaging fees to 0
    deliveryFees[importedLocation] = 0;
    // Cycle through the community orders of each imported location.
    Object.keys(importedCommunityOrders).forEach((customerOrder) => {
      // If the delivery fee exists and it is more that nothing.
      if (importedCommunityOrders[customerOrder].deliveryFee > 0) {
        // Add the delivery amount to the location's total
        deliveryFees[importedLocation] += parseFloat(
          importedCommunityOrders[customerOrder].deliveryFee,
        );
        // Add the delivery amount to the total of all locations.
        totalDeliveryFees += parseFloat(
          importedCommunityOrders[customerOrder].deliveryFee,
        );
      }
    });
  });

  // The cost of deliveries are then all added up so that we can have the total.
  Object.keys(costOfDeliveries).forEach((communityLocation) => {
    if (costOfDeliveries[communityLocation] > 0) {
      totalCostOfDeliveries += costOfDeliveries[communityLocation];
    }
  });

  // Set the total in the map to the total delivery fees.
  deliveryFees.Total = totalDeliveryFees;
  // Set the total amount.
  costOfDeliveries.Total = totalCostOfDeliveries;

  return [deliveryFees, costOfDeliveries];
}
